exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-function-content .layout[data-v-00d79f7e] {\n  padding: 26px 16px;\n  display: flex;\n  flex-direction: column;\n}\n", ""]);

// exports
